import { render } from "./addDistibution.vue?vue&type=template&id=7672cf3b&scoped=true"
import script from "./addDistibution.vue?vue&type=script&lang=js"
export * from "./addDistibution.vue?vue&type=script&lang=js"

import "./addDistibution.vue?vue&type=style&index=0&id=7672cf3b&scoped=true&lang=css"
import "./addDistibution.vue?vue&type=style&index=1&id=7672cf3b&lang=css"

import exportComponent from "/Users/basil/Documents/rishad/ncp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7672cf3b"]])

export default __exports__